export default {
  gleifLogo: {
    small: '',
    full: '',
  },
  linkUse: {
    small: '',
    full: '',
  },
  linkChallenge: {
    small: '',
    full: '',
  },
  linkBack: {
    small: '',
    full: '',
  },
  upperSearch: {
    small: '',
    full: '',
  },
  describeText: {
    small: '',
    full: '',
  },
  suggested: {
    small: '',
    full: '',
  },
  suggestedHeading: {
    small: '',
    full: '',
  },
  suggestedDescription: {
    small: '',
    full: '',
  },
  suggestedSearches: {
    small: '',
    full: '',
  },
  newsbar: {
    small: '',
    full: '',
  },
  newsbarNew: {
    small: '',
    full: '',
  },
  newsbarItems: {
    small: '',
    full: '',
  },
  newsbarMore: {
    small: '',
    full: '',
  },
  newsbarClose: {
    small: 'Hide the news and updates bar.',
    full: '',
  },
  newsbarRefresh: {
    small: 'Try again and refresh page',
    full: '',
  },
  searchBar: {
    small: '',
    full: '',
  },
  searchBarHeading: {
    small: '',
    full: '',
  },
  searchExpert: {
    small: 'Select to switch advanced search options on or off.',
    full: 'Advanced search options allow you to add and combine logical search operators using all LEI data fields.',
  },
  searchBarSearchBox: {
    small: '',
    full: '',
  },
  searchBarScope: {
    small: '',
    full: '- Find LEI: search in LEI, Names, BIC, Addresses\n' +
      '- Who is owned by...: Find children of this legal entity\n' +
      '- Who owns... Find parent entities of this legal entity',
  },
  searchBarTerm: {
    small: 'Enter a search query to see a preview of the search results.',
    full: 'Preview search results are not stored. You need to submit your search query by pressing Enter or the Searchbutton to add it to the search history, and generate a URL that can be shared.',
  },
  searchBarQuery: {
    small: 'Submit your search query.',
    full: 'Submitting your search query will create a unique URL for this search query which you can share, and find in your browser history.',
  },
  searchBarAddFilter: {
    small: 'Select LEI data fields to filter the search To search by e.g. Country or Legal Form codes, use filters.',
    full: 'Selecting LEI data fields to search restricts any search queries you submit to only those specified fields. You can remove the filters by clicking the close ("X") button.',
  },
  searchBarFilterItems: {
    small: 'Use the LEI data field labels for help texts on rollover. ',
    full: 'Select a value to apply this filter. This will restrict your search to only data that matches the value you choose.',
  },
  searchResultsCounts: {
    small: '',
    full: '',
  },
  searchResultsOptions: {
    small: '',
    full: '',
  },
  searchResultsExport: {
    small: '',
    full: '',
  },
  searchResultsView: {
    small: '',
    full: '',
  },
  searchResultsColumn: {
    small: '',
    full: '',
  },
  searchResultsColumnHeading: {
    small: 'Select an LEI record to export.',
    full: '',
  },
  searchResultsResultRow: {
    small: '',
    full: '',
  },
  searchResultsBell: {
    small: '',
    full: '',
  },
  searchResultsRows: {
    small: 'See related records for this LEI data record.',
    full: '',
  },
  searchResultsMatches: {
    small: '',
    full: '',
  },
  searchResultsInfo: {
    small: '',
    full: '',
  },
  searchResultsInfoText: {
    small: '',
    full: '',
  },
  searchResultsInfoLink: {
    small: '',
    full: '',
  },
  searchResultsPagination: {
    small: '',
    full: '',
  },
  searchResultsPagination2: {
    small: '',
    full: '',
  },
  gleifFooter: {
    small: '',
    full: '',
  },
  sidebar: {
    small: '',
    full: '',
  },
}



// WEBPACK FOOTER //
// ./src/constants/tooltips/simple.js